<template>
  <!-- Required by the .container-full-width breakout: 100vw includes the
       scrollbar, so full-bleed elements overhang the visible area by ~15px.
       This swallows the overhang instead of letting it become a horizontal
       scrollbar. `clip` rather than `hidden` so it doesn't become a scroll
       container and break the sticky header. -->
  <div class="overflow-x-clip">
    <SiteHeader :menu="primaryMenu" />

    <slot />

    <SiteFooter
      :collections="footerCollectionsMenu"
      :neighborhoods="footerNeighborhoodsMenu"
    />
  </div>
</template>

<script setup>
import { useQuery } from "@vue/apollo-composable";
import { GET_MENUS } from "~/graphql/GetMenus";

const { result, loading } = useQuery(GET_MENUS);

const primaryMenu = computed(() => {
  const flatMenu = result.value?.primaryMenu?.menuItems?.nodes ?? [];
  if (flatMenu.length === 0) return [];
  return flatMenu.length === 0 ? [] : flatListToHierarchical(flatMenu);
});

const footerCollectionsMenu = computed(() => {
  return result.value?.footerCollectionsMenu?.nodes ?? [];
});

const footerNeighborhoodsMenu = computed(() => {
  return result.value?.footerNeighborhoodsMenu?.nodes ?? [];
});
</script>
